export default __webpack_public_path__ + "static/media/apptension-team.9ec10139.png";